import { LocalStorageService } from "@topline/services/localStorageService";

(module => {
    module.component("agGridPageSize", {
        template: require("./agGridPageSizeComponent.html"),
        bindings: {
            gridName: "@",
            defaultPageSize: "<",
            changePageSize: "&"
        },
        controller: [LocalStorageService.componentName, "$timeout", agGridPageSizeComponent]
    });

    function agGridPageSizeComponent(
        this: $TSFixMe,
        localStorageService: LocalStorageService,
        $timeout: ng.ITimeoutService
    ) {
        const $ctrl = this;

        $ctrl.pageSizes = [
            { label: "10", value: 10 },
            { label: "25", value: 25 },
            { label: "50", value: 50 },
            { label: "100", value: 100 },
            { label: "All", value: 999999 }
        ];

        $ctrl.selectedPageSize = null;

        $ctrl.$onInit = () => {
            if (!$ctrl.gridName || !$ctrl.defaultPageSize) {
                return;
            }

            $ctrl.selectedPageSize = localStorageService.getItem(`${$ctrl.gridName}PageSize`)
                ? localStorageService.getItem(`${$ctrl.gridName}PageSize`)
                : $ctrl.defaultPageSize;

            localStorageService.setItem(`${$ctrl.gridName}PageSize`, $ctrl.selectedPageSize);
            $timeout(() => $ctrl.selectElement($ctrl.selectedPageSize));
        };

        $ctrl.selectElement = (element: $TSFixMe) => {
            $ctrl.changePageSize({ value: element });
            localStorageService.setItem(`${$ctrl.gridName}PageSize`, element);
        };
    }
})(angular.module("topline.modules"));
